<template>
    <div>
        Audio Player <button class="btn" v-on:click="play()">Play</button>
    </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';

export default {
    components: {

    },
    props: {
        url: {
            type: String,
            required: true
        },
    },
    data: function () {
        return {
            audio: false
        };
    },
    emits: [
    ],
    created: function () {
        console.log("AudioPlayer component created");
    },
    mounted: function () {
        console.log("AudioPlayer component mounted");

        //Create audio player
        this.audio = new Audio();
    },
    unmounted: function () {
        console.log("AudioPlayer component unmounted");
    },
    computed: {
    },
    methods: {
        play: function () {
            console.log("Play sound", this.url);
            this.audio.pause();
            this.audio.src = this.url;
            this.audio.play().catch(function (error) {
                console.error("Error playing sound", error);
            });
        },
    },
    watch: {
    },
    created: function () {
        console.log("created AudioPlayer");
    },
    destroyed: function () {
        console.log("AudioPlayer destroyed");
    },
    beforeDestroy: function () {
        console.log("AudioPlayer beforeDestroy");
    },
    updated: function () {
        console.log("AudioPlayer updated");
    },
};
</script>